import React, { useState } from 'react';

const ImageCarousel = ({
    images,
    caption = null,
    fill = false,
    editMode = false,
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const goToPrevious = () => {
        const isFirstImage = currentIndex === 0;
        const newIndex = isFirstImage ? images.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };

    const goToNext = () => {
        const isLastImage = currentIndex === images.length - 1;
        const newIndex = isLastImage ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    };

    const hasCarousel = images.length > 1;
    const fillWithCarousel = fill && hasCarousel;

    return images.length > 0 ? ( // Intentionally doesn't render if images array is an empty array
        <div
            style={{
                overflow: 'clip',
                position: 'relative',
                height: fill ? '100%' : 'auto',
                display: fillWithCarousel ? 'flex' : 'block',
                flexDirection: fillWithCarousel ? 'column' : undefined,
            }}
        >
            <div
                style={{
                    textAlign: 'center',
                    height: fillWithCarousel ? '0' : fill ? '100%' : 'auto',
                    flexGrow: fillWithCarousel ? 1 : undefined,
                    minHeight: fillWithCarousel ? 0 : undefined,
                }}
            >
                <img
                    src={images[currentIndex]}
                    style={{
                        width: '100%',
                        height: fill ? '100%' : 'auto',
                        objectFit: fill ? 'cover' : 'initial',
                        objectPosition: 'center center',
                        pointerEvents: 'none',
                    }}
                />
            </div>
            {caption ? (
                <div
                    className="py-1 px-3"
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        height: '34px',
                        backgroundColor: '#2F2B4399',
                        color: 'white',
                    }}
                >
                    {caption}
                </div>
            ) : null}
            {hasCarousel ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '12px 28px',
                        flexShrink: 0,
                    }}
                >
                    <div
                        onClick={!editMode ? goToPrevious : undefined}
                        style={{ cursor: !editMode ? 'pointer' : 'auto' }}
                    >
                        <svg
                            width="10"
                            height="15"
                            viewBox="0 0 6 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M5.89017 0.123348C6.03661 0.287811 6.03661 0.55446 5.89017 0.718924L1.65533 5.47476L5.89017 10.2306C6.03661 10.3951 6.03661 10.6617 5.89017 10.8262C5.74372 10.9906 5.50628 10.9906 5.35983 10.8262L0.859835 5.77255C0.713388 5.60809 0.713388 5.34144 0.859835 5.17698L5.35983 0.123348C5.50628 -0.0411159 5.74372 -0.0411159 5.89017 0.123348Z"
                                fill="#2F2B43"
                            />
                        </svg>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {images.map((_, index) => (
                            <div
                                key={index}
                                style={{
                                    height: '6px',
                                    width: '6px',
                                    borderRadius: '50%',
                                    backgroundColor:
                                        currentIndex === index
                                            ? 'rgba(47, 43, 67, 1)'
                                            : 'rgba(130, 128, 142, 1)',
                                    margin: '0 1.5px',
                                }}
                            />
                        ))}
                    </div>
                    <div
                        onClick={!editMode ? goToNext : undefined}
                        style={{ cursor: !editMode ? 'pointer' : 'auto' }}
                    >
                        <svg
                            width="10"
                            height="15"
                            viewBox="0 0 6 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M0.109835 10.8262C-0.0366117 10.6617 -0.0366117 10.3951 0.109835 10.2306L4.34467 5.47476L0.109835 0.718922C-0.0366117 0.554457 -0.0366117 0.287809 0.109835 0.123344C0.256282 -0.0411186 0.493718 -0.0411186 0.640165 0.123344L5.14016 5.17697C5.28661 5.34144 5.28661 5.60809 5.14016 5.77255L0.640165 10.8262C0.493718 10.9906 0.256282 10.9906 0.109835 10.8262Z"
                                fill="#2F2B43"
                            />
                        </svg>
                    </div>
                </div>
            ) : null}
        </div>
    ) : null;
};

export default ImageCarousel;
